import React, { useRef } from "react";
import { Dialog } from "primereact/dialog";
import { useQuery } from "@tanstack/react-query";
import { productService } from "../../services/product";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import formatDate from "../../components/ui/dateFormat";

export default function DispatchDetails({ dataRow, visible, setVisible }) {
  const { data: product, isLoading } = useQuery({
    queryKey: ["dispatchProduct", dataRow?.belgeNo, dataRow?.parti,dataRow?.cariId],
    queryFn: () =>
      productService.getDispatchProductDetails(
        dataRow?.belgeNo || "",
        dataRow?.parti || "",
        dataRow?.cariId || ""
      ),
    enabled: !!(visible && dataRow?.belgeNo && dataRow?.parti), // Kesin boolean dönüşümü
  });

  const formatNumber = (value) => {
    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  };
  const sevkKgRawTemplate = (rowData) => {
    return formatNumber(rowData.sevkKgRaw);
  };
  const sevkMtTemplate = (rowData) => {
    return formatNumber(rowData.sevkMt);
  };

   
  const contentRef = useRef(null);
  const handlePrint = () => {
    const dialogContent = document.querySelector(".edata").innerHTML;

    const styles = Array.from(
      document.head.querySelectorAll("style, link[rel='stylesheet']")
    )
      .map((style) => style.outerHTML)
      .join("\n");

    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "none";

    document.body.appendChild(iframe);

    const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

    iframeDoc.open();
    iframeDoc.write(`
    <html>
        <head>
          <title>Yazdır</title>
          ${styles}
          <style>
          h1 {text-align: center;}
            @page {
              margin: 0;
            }
            body {
              margin: 0;
              padding: 20px;
              box-sizing: border-box;
            }
            .print-content {
              width: 100%;
              height: auto;
              overflow: hidden;
            }
            table {
              width: 100%;
              border-collapse: collapse;
              margin-bottom: 20px;
            }
            table, th, td {
              border: 1px solid #333;
            }
            th, td {
              padding: 8px;
              text-align: left;
            }
          </style>
        </head>
        <body>
          <div style="display: flex; justify-content: space-between; align-items: center;">
            <h4>${product && product[0]?.unvan}</h4>
            <h3>Sevk Çeki Detayı</h3>
            <h4>BOYER TEKSTİL</h4>
          </div>
          <table>
            <tr> 
              <th>Ürün</th>
              <td colspan="3">${dataRow?.urun.trim()}</td>
            </tr>
            <tr>
              <th>Tarih</th>
              <td>${formatDate(dataRow?.sevkTar)}</td>
              <th>Metre</th>
              <td>${formatNumber(dataRow?.sevkMt)}</td>
            </tr>
            <tr>
              <th>İşlem</th>
              <td>${dataRow?.kodu}</td>
              <th>Kilo</th>
              <td>${formatNumber(dataRow?.sevkKg)}</td>
            </tr>
            <tr>
              <th>Parti</th>
              <td>${dataRow?.belgeNo + " / " + dataRow?.parti}</td>
              <th>Top Sayısı</th>
              <td>${product?.length}</td>
            </tr>
          </table>
          <div class="print-content">
            ${dialogContent}
          </div>
        </body>
      </html>
    `);
    iframeDoc.close();

    // Yazdırma işlemini başlat
    iframe.contentWindow.focus();
    iframe.contentWindow.print();

    // Yazdırma tamamlandıktan sonra iframe'i kaldır
    setTimeout(() => {
      document.body.removeChild(iframe);
    }, 1000);
  };

  const cols = [
    { field: "barkod", header: "Barkod" },
    { field: "sevkKg", header: "Sevk Kg", align: "center" },
    {
      field: "sevkKgRaw",
      header: "Net Kg",
      body: sevkKgRawTemplate,
      align: "center",
    },
    {
      field: "sevkMt",
      header: "Sevk Mt",
      body: sevkMtTemplate,
      align: "center",
    },
  ];
  const header = (
    <div className="flex justify-content-between p-0 m-0">
      <span className="align-content-center">Sevk Çeki Listesi</span>
      <Button
        type="button"
        icon="pi pi-print"
        severity="success"
        text
        className="h-2rem p-0 m-0"
        rounded
        onClick={handlePrint}
      />
    </div>
  );
  return (
    <Dialog
      className="max-w-full w-11 md:w-10 xl:w-8 "
      visible={visible}
      header={header}
      onHide={() => setVisible(false)}
    >
      <div ref={contentRef}>
        <div className="formgrid grid mt-3">
          <div className=" sm:col-12 md:col-6 lg:col-4  xl:col-4 col-12">
            <div className="p-inputgroup flex-1 w-12 pb-2">
              <span className="p-inputgroup-addon w-7rem md:w-4rem">Tarih</span>
              <InputText
                className="p-inputgroup"
                value={formatDate(dataRow?.sevkTar)}
                readOnly
              />
            </div>
          </div>
          <div className=" sm:col-12 md:col-6 lg:col-4  xl:col-4  col-12">
            <div className="p-inputgroup flex-1 w-12 pb-2">
              <span className="p-inputgroup-addon w-7rem md:w-4rem">Ürün</span>
              <InputText
                className="p-inputgroup"
                value={dataRow?.urun.trim()}
                readOnly
              />
            </div>
          </div>
          <div className=" sm:col-12 md:col-6 lg:col-4  xl:col-4  col-12">
            <div className="p-inputgroup flex-1 w-12 pb-2">
              <span className="p-inputgroup-addon w-7rem md:w-4rem">İşlem</span>
              <InputText
                className="p-inputgroup"
                value={dataRow?.kodu}
                readOnly
              />
            </div>
          </div>
          <div className=" sm:col-12 md:col-6 lg:col-4  xl:col-4 col-12">
            <div className="p-inputgroup flex-1 w-12 pb-2">
              <span className="p-inputgroup-addon w-7rem md:w-4rem">Parti</span>
              <InputText
                className="p-inputgroup"
                value={dataRow?.belgeNo + " / " + dataRow?.parti}
                readOnly
              />
            </div>
          </div>
          <div className=" sm:col-12 md:col-6 lg:col-4  xl:col-4 col-12">
            <div className="p-inputgroup flex-1 w-12 pb-2">
              <span className="p-inputgroup-addon w-7rem md:w-4rem">Kilo</span>
              <InputText
                className="p-inputgroup"
                value={formatNumber(dataRow?.sevkKg)}
                readOnly
              />
            </div>
          </div>
          <div className=" sm:col-12 md:col-6 lg:col-4  xl:col-4 col-12">
            <div className="p-inputgroup flex-1 w-12 pb-2">
              <span className="p-inputgroup-addon w-7rem md:w-4rem">Metre</span>
              <InputText
                className="p-inputgroup"
                value={formatNumber(dataRow?.sevkMt)}
                readOnly
              />
            </div>
          </div>
        </div>
        
        <DataTable
          loading={isLoading} className="edata" id="edata"
          emptyMessage="Liste Boş"
          showGridlines
          value={product || []}
        >
          {cols.map((col, i) => (
            <Column
              className="max-w-min"
              key={i}
              align={col.align}
              field={col.field}
              header={col.header}
              body={col.body}
            />
          ))}
        </DataTable>
    
      </div>
    </Dialog>
  );
}
